import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { loginUser, clearError } from '../../store/slices/authSlice'
import {
  Form, Card, Row, Col, Typography,
  UserOutlined, LockOutlined,
  CustomInput, CustomButton, showToast, Colors
} from '../../utils/commonImports'
import Logo from '../../assets/shared/branding/admin-logo.png'

const { Title } = Typography

const Login = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { error, loading, isAuthenticated } = useSelector((state) => state.auth)

  useEffect(() => {
    if (isAuthenticated) {
      showToast('Login Successful')
      navigate('/admin')
    }

    if (error) {
      showToast(error, 'error')
      dispatch(clearError())
    }
  }, [dispatch, error, isAuthenticated, navigate])

  const onFinish = async () => {
    dispatch(loginUser({ email, password }))
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
      <Row style={{ width: '100%', minHeight: '100vh' }}>
        <Col xs={0} md={12}>
          <div 
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              paddingLeft: '40px',
              paddingRight: '40px',
              background: `linear-gradient(135deg, ${Colors.primary} 70%, ${Colors.darkGray} 100%)`,
              color: Colors.white,
              minHeight: '100vh',
              textAlign: 'center'
            }}
          >
            <Title level={2} style={{ color: Colors.white, textAlign: 'center', margin: 0 }}>
              Neo Terra Accounts
            </Title>
            <p style={{ textAlign: 'center', fontSize: '16px', opacity: 0.9, margin: '16px 0 0 0' }}>
              Streamline your accounts & invoicing with our comprehensive management system
            </p>
          </div>
        </Col>
        
        <Col xs={24} md={12}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingLeft: '40px',
            paddingRight: '40px',
            minHeight: '100vh'
          }}>
            <Card
              style={{
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                borderRadius: '12px',
                border: `1px solid ${Colors.lightGray}`,
                width: '100%',
                maxWidth: '400px'
              }}
            >
              <div style={{ textAlign: 'center', marginBottom: 30 }}>
                <img 
                  src={Logo} 
                  alt="Company Logo" 
                  style={{ height: 90, display: 'block', margin: '0 auto 20px auto', borderRadius: 100 }}
                />
                <Title level={3} style={{ color: Colors.primary, margin: 0 }}>
                  Neo Terra Admin
                </Title>
                <p style={{ color: Colors.gray, margin: '8px 0 0 0' }}>
                  Sign in to your account
                </p>
              </div>

              <Form name="login" onFinish={onFinish} layout="vertical" size="large">
                <Form.Item
                  name="email"
                  rules={[
                    { required: true, message: 'Please input your email!' }
                  ]}
                >
                  <CustomInput
                    prefix={<UserOutlined style={{ color: Colors.gray }} />}
                    placeholder="Enter your Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[{ required: true, message: 'Please input your password!' }]}
                >
                  <CustomInput
                    type="password"
                    prefix={<LockOutlined style={{ color: Colors.gray }} />}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.Item>

                <Form.Item>
                  <CustomButton height={34} htmlType="submit" disabled={loading}>
                    {loading ? 'Signing In....' : 'Sign In'}
                  </CustomButton>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Login